var map = {
	"./bug.svg": 991,
	"./cardBackground.svg": 251,
	"./dark.svg": 315,
	"./dragon.svg": 923,
	"./electric.svg": 736,
	"./fairy.svg": 430,
	"./fighting.svg": 781,
	"./fire.svg": 201,
	"./flying.svg": 472,
	"./ghost.svg": 811,
	"./github.svg": 2,
	"./grass.svg": 653,
	"./ground.svg": 65,
	"./ice.svg": 172,
	"./linkedin.svg": 657,
	"./logoPokemon.svg": 757,
	"./normal.svg": 143,
	"./poison.svg": 690,
	"./psychic.svg": 679,
	"./rock.svg": 540,
	"./steel.svg": 990,
	"./water.svg": 770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 866;